import {resize, resizeC, drawImage0, drawText, getPathBoundingBox, drawTextPathOnCtx, textToSvgPath, scaleSvgPathString, sanitizePath} from './Funcs.js';
import {drawPath, drawCurvePath, drawImage, drawImageClip, createScreenTransformationMatrix, applyMatrixToCtx, resizeAnimate, drawClipBoardAnimate} from './Funcs.js';
import {resizeGroupForClip, drawGroup, drawSvgCircle, drawSvgSquare, drawSvgRect, drawSvgEllipse, getImage} from './Funcs.js';

let cRects = [];
const CLIPBOARD_LIMIT = 10; // or whatever max size you want
const RECT_HEIGHT  = 75;
const PAGE_WIDTH = 150;
const PAGE_HEIGHT = 768;

let webId = "";
let demo = true;
let redrawFunc = null;


export function restoreClipBoard(w, d, rd)
{

   webId = w;
   demo = d;
   redrawFunc = rd;
   let clipBoard=localStorage.getItem('clipBoard');
    
    if(clipBoard == undefined || clipBoard == "")
    {
        cRects = [];
    }
    else
    {
      cRects = JSON.parse(clipBoard);
    }
}

export function saveClipBoard()
{

  let clipBoardString = JSON.stringify(cRects);
  localStorage.setItem('clipBoard', clipBoardString);
}


export function createLoop(callback, delay = 100) {
  let timerId;
  let running = false;

  function loop() {
    callback(stop); // pass a stop() function into your callback
    if (running) {
      timerId = setTimeout(loop, delay);
    }
  }

  function start() {
    if (!running) {
      running = true;
      loop();
    }
  }

  function stop() {
    running = false;
    clearTimeout(timerId);
  }

  return { start, stop };
}

export const clipBoardToPage = (clipX, clipY, viewPortRef, pageSizeRef) => {
  const { offsetX, offsetY, zoom } = viewPortRef.current;
  const { width } = pageSizeRef.current;

  const spacing = 50; // extra gap between page and clipboard
  const clipOffsetX = offsetX + width + spacing; // shift clipboard right of page

  /*
  x: (pageX + offsetX) * zoom,
  y: (pageY + offsetY) * zoom,
  */

  return {
    /*
    x: (clipX + clipOffsetX) * zoom,
    y: (clipY + offsetY) * zoom,
    */
    x: (clipX + width + spacing) ,
    y: (clipY )    
  };
};


const clipBoardToScreen = (clipX, clipY, viewPortRef, pageSizeRef) => {
    const { offsetX, offsetY, zoom } = viewPortRef.current;
    const { width } = pageSizeRef.current;
  
    const spacing = 50; // extra gap between page and clipboard
    const clipOffsetX = offsetX + width + spacing; // shift clipboard right of page
  
    /*
    x: (pageX + offsetX) * zoom,
    y: (pageY + offsetY) * zoom,
    */

    return {
      /*
      x: (clipX + clipOffsetX) * zoom,
      y: (clipY + offsetY) * zoom,
      */
      x: ((clipX + offsetX) * zoom) + ((width + spacing)*zoom),
      y: (clipY + offsetY) * zoom,

      
    };
  };

  
  const screenToClipBoard = (screenX, screenY, viewPortRef, pageSizeRef) => {
    const { offsetX, offsetY, zoom } = viewPortRef.current;
    const { width } = pageSizeRef.current;
  
    const spacing = 50;
    const clipOffsetX = offsetX + width + spacing;
  
    return {
      x: screenX / zoom - clipOffsetX,
      y: screenY / zoom - offsetY,
    };
  };

  function sumHeight()
  {
    let height  = 0;

    
    // --- Draw rects inside clipboard ---
    if (!cRects || cRects.length === 0) return 0;
    
    cRects.forEach((rect) => {
      height = height + rect.h;
    });

    return height;
  }

  function shiftUp()
  {

    // --- Draw rects inside clipboard ---
    if (!cRects || cRects.length === 0) return 0;
    
    let height = RECT_HEIGHT;
    cRects.forEach((rect) => {
        rect.y = rect.y - height;
        if(rect.pasteRect)
        {
          let p= rect.pasteRect;
          p.y = p.y - height;
        }
    });
    
  }

  export function getClipRect(index)
  {
    if(index < 0 || index >= cRects.length)
    {
      return null;
    }
    return cRects[index];
  }

  export function addToClipBoard(rect) {
    // Deep copy rect (handles nested objects/arrays)
    let newRect = JSON.parse(JSON.stringify(rect[0]));

    
    // console.log(JSON.stringify(rect[0]));
    newRect.x = 0;
    newRect.y = 0;
    newRect.w = PAGE_WIDTH;    
    newRect.h = RECT_HEIGHT;


    const scale = Math.min(
      newRect.w / rect[0].w,
      newRect.h / rect[0].h);
  
    let rZoomX = scale;
    let rZoomY = scale;

    /*
    let rZoomX = newRect.w/rect[0].w;
    let rZoomY = newRect.h/rect[0].h;

    if(newRect.w < newRect.h)
    {
      rZoomY = rZoomX
    }
    else
    {
      rZoomX = rZoomY;
    }
    */

    if(rect[0].subType === 'Image')
    {

      let pasteRect = JSON.parse(JSON.stringify(newRect));
      // pasteRect.w = rect[0].w*rZoomX;
      // pasteRect.h = rect[0].h*rZoomY;
      newRect.pasteRect = pasteRect;
    }

    if(rect[0].subType === 'Text')
    {
      let pasteRect = JSON.parse(JSON.stringify(newRect));
      // pasteRect.w = rect[0].w*rZoomX;
      // pasteRect.h = rect[0].h*rZoomY;
      newRect.pasteRect = pasteRect;
    }

    if(rect[0].subType === 'SvgCircle' || 
      rect[0].subType === 'SvgSquare' ||
      rect[0].subType === 'SvgRect' ||
      rect[0].subType === 'SvgEllipse')
    {
      let pasteRect = JSON.parse(JSON.stringify(newRect));
      // pasteRect.w = rect[0].w*rZoomX;
      // pasteRect.h = rect[0].h*rZoomY;
      newRect.pasteRect = pasteRect;
      let iX = newRect.pasteRect.imagePanX;
      let iY = newRect.pasteRect.imagePanY;
      newRect.pasteRect.imagePanX = rZoomX*iX;
      newRect.pasteRect.imagePanY = rZoomY*iY;

    }

    if(rect[0].subType === 'Animate')
    {
      let pasteRect = JSON.parse(JSON.stringify(rect[0]));
      let tRect = JSON.parse(JSON.stringify(rect[0]));

      tRect.x = 0;
      tRect.y = 0;
      pasteRect.x = 0;
      pasteRect.y = 0;
      resizeAnimate(pasteRect,tRect,rZoomX,rZoomY);
      newRect.pasteRect = pasteRect;

    }

    if(rect[0].type === 'Group')
    {
      let pasteRect = JSON.parse(JSON.stringify(rect[0]));
      let tRect = JSON.parse(JSON.stringify(rect[0]));

      tRect.x = 0;
      tRect.y = 0;
      pasteRect.x = 0;
      pasteRect.y = 0;
      resizeGroupForClip(tRect,pasteRect,rZoomX,rZoomY);
      newRect.pasteRect = pasteRect;

    }

    if(rect[0].type === 'Prect')
    {      

      const newPath = resize(newRect.path, rZoomX, rZoomY);      
      let pasteRect = JSON.parse(JSON.stringify(rect[0]));
      pasteRect.path = newPath;   
      pasteRect.x = 0;
      pasteRect.y = 0;  
      pasteRect.w = rect[0].w*rZoomX;
      pasteRect.h = rect[0].h*rZoomY;

      let iX = pasteRect.imagePanX;
      let iY = pasteRect.imagePanY;
      pasteRect.imagePanX = rZoomX*iX;
      pasteRect.imagePanY = rZoomY*iY;

      newRect.pasteRect = pasteRect;

      newRect.path = newPath;
    }

    if(rect[0].type === 'Bezier')
    {      
      // let rZoomX = newRect.w/rect[0].w;
      // let rZoomY = newRect.h/rect[0].h;


      const newPath = resize(newRect.path, rZoomX, rZoomY);
      newRect.path = newPath;

      const newControl = resizeC(newRect.control, rZoomX, rZoomY);
      newRect.control = newControl;

       let pasteRect = JSON.parse(JSON.stringify(rect[0]));
      
       pasteRect.x = 0;
       pasteRect.y = 0;  
       pasteRect.w = rect[0].w*rZoomX;
       pasteRect.h = rect[0].h*rZoomY;

      let iX = pasteRect.imagePanX;
      let iY = pasteRect.imagePanY;
      pasteRect.imagePanX = rZoomX*iX;
      pasteRect.imagePanY = rZoomY*iY;


      pasteRect.path = newPath;     
      pasteRect.control = newControl;
      // pasteRect.w = rect[0].w*rZoomX;
      // pasteRect.h = rect[0].h*rZoomY;
      newRect.pasteRect = pasteRect;


    }

    if(rect[0].type === 'SvgText')
    {

      let pasteRect = JSON.parse(JSON.stringify(rect[0]));

      
      let tZoomX = newRect.w / newRect.originalWidth;
      let tZoomY = newRect.h / newRect.originalHeight;
      // newRect.rZoomX = rZoomX;
      // newRect.rZoomY = rZoomY;
      


      
      pasteRect.x = 0;
      pasteRect.y = 0;  
      pasteRect.w = newRect.w; // *rZoomX;
      pasteRect.h = newRect.h; // *rZoomY;
      pasteRect.rZoomX = tZoomX;
      pasteRect.rZoomY = tZoomY;

      


      
      const originalSvgPath = rect[0].originalSvgPath;
      
      if(originalSvgPath !== null && originalSvgPath !== "")
      {
        let scaledPathString = scaleSvgPathString(originalSvgPath, tZoomX, tZoomY);
        let sane = sanitizePath(scaledPathString);
        // newRect.svgText = sane;
         pasteRect.svgText = sane;
      }    
       newRect.pasteRect = pasteRect;
  
    }

      
    if (cRects.length >= CLIPBOARD_LIMIT) {
      // Remove first and push to end
      const removed = cRects.shift();
      shiftUp();

      let adjHeight = sumHeight();
      newRect.y = adjHeight;
      if(newRect.pasteRect)
      {
        newRect.pasteRect.y = adjHeight;
        if(newRect.pasteRect.mObj)
        {
          newRect.pasteRect.mObj.y = adjHeight;
        }
        if(newRect.pasteRect.mPath)
        {
          newRect.pasteRect.mPath.y = adjHeight;
        }

      }
      cRects.push(newRect);
    } else {
      let adjHeight = sumHeight();
      newRect.y = adjHeight;
      if(newRect.pasteRect)
      {
        newRect.pasteRect.y = adjHeight;

        if(newRect.pasteRect.mObj)
        {          
          newRect.pasteRect.mObj.y = adjHeight - newRect.pasteRect.offsetViewY;
        }
        if(newRect.pasteRect.mPath)
        {
          newRect.pasteRect.mPath.y = adjHeight - newRect.pasteRect.offsetViewY;
        }
      }
      cRects.push(newRect);
    }
  }

  export function clipBoardHit(x,y, vp, ps)
  {
    
    if(vp == null || ps == null)
    {
      console.log("NULL in wrong place");
      return false;
    }

    const { x: xR, y: yR } = screenToClipBoard(x, y, vp, ps);

    if(xR >=0 && xR<PAGE_WIDTH && yR >=0 && yR < PAGE_HEIGHT)
    {      
      return true;
    }
    else
    {
      return false;
    }
  }


  export function getClipIndex(x,y, vp, ps)
  {
    if(vp == null || ps == null)
    {
      console.log("NULL in wrong place");
      return false;
    }

    const { x: xR, y: yR } = screenToClipBoard(x, y, vp, ps);

    if(cRects.length == 0)
    {
       return -1;
    }

    let maxHeight = cRects.length*RECT_HEIGHT;

    if(xR >=0 && xR<PAGE_WIDTH && yR < maxHeight)
    {
      for (let i=0; i< cRects.length; i++)
      {
          if(yR > cRects[i].y && yR < cRects[i].y+cRects[i].h)
          {
            return i;
          }
      }            
    }

    return -1;

  }

  export function clearClipBoard()
  {
    cRects = [];
  }

  export const drawClipBoard = (ctx, viewPortRef, pageSizeRef, onClip, index, auth, demo) => {
    const { offsetX, offsetY, zoom } = viewPortRef.current;
    const width = PAGE_WIDTH;
    const height = PAGE_HEIGHT;
    

    const { x: xR, y: yR } = clipBoardToScreen(0, 0, viewPortRef, pageSizeRef);
    
    const pageW = width * zoom;
    const pageH = height * zoom;
      
  
    // --- Draw clipboard background ---
    ctx.save();
    ctx.shadowColor = 'rgba(0, 0, 0, 0.25)';
    ctx.shadowBlur = 10;
    ctx.shadowOffsetX = 5;
    ctx.shadowOffsetY = 5;
  
    ctx.fillStyle = '#f8f8f4'; // slightly warm off-white
    ctx.fillRect(xR, yR, pageW, pageH);
    ctx.restore();
  
    if(onClip === false)
    {
      ctx.strokeStyle = '#666';
      ctx.lineWidth = 1;
    }
    else
    {
      ctx.strokeStyle = 'red';
      ctx.lineWidth = 5;

    }
    ctx.strokeRect(xR, yR, pageW, pageH);
  
    // --- Draw rects inside clipboard ---
    if (!cRects || cRects.length === 0) return;
  
    
    for (let i=0; i< cRects.length; i++)
    {
      const rect = cRects[i];
          
      
      const { x, y } = clipBoardToScreen(rect.x, rect.y, viewPortRef, pageSizeRef);
      const w = rect.w * zoom;
      const h = rect.h * zoom;
      
      const { width } = pageSizeRef.current;
    
      const spacing = 50; // extra gap between page and clipboard
      const clipOffsetX = offsetX + width + spacing; // shift clipboard right of page

  
      ctx.fillStyle = rect.fillStyle || "rgba(0,0,0,0.05)";
      ctx.fillRect(x, y, w, h);
  
      ctx.strokeStyle = rect.strokeStyle || "#333";
      ctx.lineWidth = 1;


      // console.log(JSON.stringify(rect));
      // console.log("HELP");
      let matrix = createScreenTransformationMatrix(zoom,zoom,clipOffsetX,offsetY);

      ctx.save();
      applyMatrixToCtx(ctx,matrix);


      
      if(rect.type === 'Group')
      {
        const queue = [rect.pasteRect];


        while(queue.length > 0)
        {
          const r = queue.shift();
          
          if(r.type === 'Group')
          {
            ctx.save();

            if(r.type === 'Group' && r.hasParent === false)
            {
                drawGroup(ctx,r.x,r.y,r.w,r.h, r);
            }
            else
            {
                drawGroup(ctx,r.x,r.y+i*RECT_HEIGHT,r.w,r.h, r);
                        
            }
  
             // If the current rect is a group, add its children to the queue
            if (r.children && r.children.length > 0) 
            {
                r.children.forEach(child => {
                queue.push(child); // Add each child to the queue for later drawing
                });
            }
            ctx.restore();

          }
          else
          {

            
            ctx.fillStyle = "rgba(0, 0, 0, 0.05)"; 

            if(r.hasParent === false)
            {
              ctx.fillRect(r.x,r.y,r.w,r.h);                
            }
            else
            {
              ctx.fillRect(r.x,r.y+i*RECT_HEIGHT,r.w,r.h);                
            }

          }
    
        }
      }

      if(rect.subType === 'SvgCircle')
      {
        if(rect.pasteRect)
        {
          let p = rect.pasteRect;
          ctx.save();      
          drawSvgCircle(ctx,p.x,p.y,p.w,p.h, rect);

          if (rect.imageName !== "")
          { 
            
            let iCache = getImage(p.imageName, webId, demo);                                              
            drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, iCache,  demo, p, viewPortRef);      
//              drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, demo, p, viewPortRef, redrawFunc);                                     
          }  
          ctx.restore();
        }
      }

      if(rect.subType === 'SvgSquare')
      {
        if(rect.pasteRect)
        {
          let p = rect.pasteRect;
          ctx.save();      
          drawSvgSquare(ctx,p.x,p.y,p.w,p.h, rect);


          if (rect.imageName !== "")
          { 
            let iCache = getImage(p.imageName, webId, demo);                                              
            drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, iCache,  demo, p, viewPortRef);      

            // drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, demo, p, viewPortRef, redrawFunc);                                     
          }  
          ctx.restore();
        }
      }

      if(rect.subType === 'SvgEllipse')
      {
        if(rect.pasteRect)
        {
          let p = rect.pasteRect;
          ctx.save();      
          drawSvgEllipse(ctx,p.x,p.y,p.w,p.h, rect);

          if (rect.imageName !== "")
          { 
            let iCache = getImage(p.imageName, webId, demo);                                              
            drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, iCache,  demo, p, viewPortRef);      

            // drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, demo, p, viewPortRef, redrawFunc);                                     
          }  
          ctx.restore();
        }
      }
      if(rect.subType === 'SvgRect')
      {
        if(rect.pasteRect)
        {
          let p = rect.pasteRect;
          ctx.save();      
          drawSvgRect(ctx,p.x,p.y,p.w,p.h, rect);

          if (rect.imageName !== "")
          { 
            let iCache = getImage(p.imageName, webId, demo);                                              
            drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, iCache,  demo, p, viewPortRef);      

            // drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, demo, p, viewPortRef, redrawFunc);                                     
          }  
          ctx.restore();
        }
      }



      if(rect.type === 'Prect')
      {
        // console.log(JSON.stringify(rect));
        // console.log("HELP");
        // drawPath(ctx,rect.x,rect.y,rect.path, viewPortRef, pageSizeRef);  

        ctx.save();
        if(rect.pasteRect)
        {
        
          let p = rect.pasteRect;
          drawPath(ctx,p, viewPortRef);

          if (p.imageName !== "")
          {     
            ctx.save();               

            let iCache = getImage(p.imageName, webId, demo);                                              
            drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, iCache,  demo, p, viewPortRef);      

            // drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, demo, p, viewPortRef, redrawFunc);        
            ctx.restore();  
          }

        }

        ctx.restore();
      }

      if(rect.type === 'Bezier')
      {
        ctx.save();
        if(rect.pasteRect)
        {
          let p = rect.pasteRect;
          // drawCurvePath(ctx,rect.x,rect.y,rect.path, rect.control, viewPortRef, pageSizeRef);
          drawCurvePath(ctx,p, viewPortRef);

          if (p.imageName !== "")
          {     
            ctx.save();               
            // let a = p.rotation;

            let iCache = getImage(p.imageName, webId, demo);                                              
            drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, iCache,  demo, p, viewPortRef);      

            // drawImageClip(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, demo, p, viewPortRef, redrawFunc);        
            ctx.restore();  
          }

        }
        ctx.restore();
      }


      if(rect.type === 'Rectangle')
      {
        if(rect.subType === 'Image')
        {

          if(rect.pasteRect)
          {

            let p = rect.pasteRect;
            drawImage(ctx,p.x,p.y, p.w, p.h, 0, webId, p.imageName, demo, p, rect.keepAspect, rect, redrawFunc);
          }
          /*
          drawImage0(ctx,x,y, w, h, auth?.user?.webId, rect.imageName, demo, () =>
          {

            drawClipBoard(ctx, viewPortRef, pageSizeRef, onClip, index, auth);
            
          });          
          */
        }

        if(rect.subType === 'Text')
        {
          if(rect.pasteRect)
          {
            let p = rect.pasteRect;
            drawText(ctx,p.x+10,p.y+10,p.w-20,p.h-20,rect.plainText);
          }
        }

        if(rect.subType === 'Animate')
        {      
          drawClipBoardAnimate(ctx,rect.pasteRect, viewPortRef, webId, demo, redrawFunc );
        }
      }

      if(rect.type === 'SvgText')
      {          
        if(rect.pasteRect)
        {
          let r = rect.pasteRect;
          drawTextPathOnCtx(ctx, r.svgText, r.x,r.y, r.w,r.h, 0 ,r, zoom, zoom);   
        }
      }

      ctx.restore();
      
      if(i === index)
      {
        ctx.strokeStyle = "red";
        ctx.lineWidth = 3;
  
        ctx.strokeRect(x, y, w, h);
      }

  
    }
  };
  

  /*
  function drawCurvePath(ctx,x,y, lines, controls, viewPortRef, pageSizeRef) {
    const path = lines;
    const controlPath = controls;  // Assuming rect contains control points as well
  
    ctx.beginPath();
  
    // Iterate over each line in the path (each line is a cubic bezier segment)
    for (let i = 0; i < path.length; i++) {
      const line = path[i];
      const controls = controlPath[i] ? controlPath[i].controls : [];
  
      // Skip lines with no points
      if (!line.points || line.points.length < 2) continue;
  
      // Loop through the points to draw the Bézier curve segments
      for (let p = 0; p < line.points.length - 1; p++) {
        const p0 = line.points[p];
        const p3 = line.points[p + 1];
  
        // Get control points (make sure controls array has enough points)
        const control = controls[p];  // Get control point for the current segment
        const p1 = control ? { x: control.x2, y: control.y2 } : p0;  // Outgoing control for p0
        const p2 = controls[p + 1] ? { x: controls[p + 1].x1, y: controls[p + 1].y1 } : p3;  // Incoming control for p3
  
        // Calculate the points on screen with the offset from rect.x and rect.y
        const { x: xP0, y: yP0 } = clipBoardToScreen(p0.x + x, p0.y + y, viewPortRef, pageSizeRef);
        const { x: xP1, y: yP1 } = clipBoardToScreen(p1.x + x, p1.y + y, viewPortRef, pageSizeRef);
        const { x: xP2, y: yP2 } = clipBoardToScreen(p2.x + x, p2.y + y, viewPortRef, pageSizeRef);
        const { x: xP3, y: yP3 } = clipBoardToScreen(p3.x + x, p3.y + y, viewPortRef, pageSizeRef);
  
        // Start the path at the first point
        if (p === 0 ) {
          ctx.moveTo(xP0, yP0);  // Ensure that we start the path at the first point of the first line
        }
  
        // Draw cubic bezier curve
        ctx.bezierCurveTo(xP1, yP1, xP2, yP2, xP3, yP3);
  
        // Set the stroke style for the line
        ctx.strokeStyle = line.strokeColor || '#000'; // Default to black if no color is provided
        ctx.lineWidth = line.stroke || 1; // Default line width if not provided
      }
    }
  
    ctx.stroke(); // Finalize the stroke for the entire path
  }
  */

  /*
  function drawPath(ctx,x,y, lPath, viewPortRef, pageSizeRef)
  {    
      // console.log("lpath: ", JSON.stringify(lPath));

      ctx.beginPath();

      for (const line of lPath) 
      {
        for (let p = 0; p<line.points.length; p++)
        {
            let xP = line.points[p].x + x;
            let yP = line.points[p].y + y;

            // console.log("XP: ",xP);
            // console.log("YP: ", yP);
            const { x:xS, y:yS } = clipBoardToScreen(xP, yP, viewPortRef, pageSizeRef);

                                
            if(p == 0)
            {                   
              ctx.moveTo(xS, yS);  
            }
            else
            {
              ctx.lineTo(xS,yS);
            }

            ctx.strokeStyle = line.strokeColor;
            ctx.lineWidth = line.stroke;
            ctx.stroke(); // Don't forget to stroke each path
          }  
      }
  }
*/
